module.exports = __webpack_public_path__ + "img/1656.2c65b121.jpg";